import { Brand as BrandType, File } from 'backend';
import parse from 'html-react-parser';
import { Img } from '../..';
import styles from './index.module.scss';

export const Brand = ({
  id,
  name,
  logo_color,
  description,
  url,
}: BrandType & { logo_color: File }) => {
  return (
    <section className={styles.brand}>
      {!!logo_color && (
        <div className={styles.logo}>
          <Img
            src={logo_color}
            width={logo_color.width ?? 32}
            height={logo_color.height ?? 32}
            alt={name}
          />
        </div>
      )}

      {!logo_color && <div className={styles.name}>{name}</div>}

      {!!description && (
        <div className={styles.text}>
          {description.indexOf('<p>') > -1 && parse(description)}
          {description.indexOf('<p>') === -1 && <p>{description}</p>}
        </div>
      )}

      {!!url && url.includes('.') && (
        <h6>
          <a
            href={`/${id}/outbound?url=${url}`}
            target="_blank"
            rel="nofollow noreferrer"
          >
            {new URL(url.includes('http') ? url : `http://${url}`).hostname}
          </a>
        </h6>
      )}
    </section>
  );
};
